// extracted by mini-css-extract-plugin
export default {"change-password-container":"changePassword_change-password-container__8JO4E"};